<template>
  <div
    v-show="visible"
    class="c-YunPrice"
    v-loading="loading"
  >
    <div class="c-YunPrice-list">
      <div class="list-header">
        <div
          v-for="(item, index) in Columns"
          :key="index"
          :class="[item.className ? item.className : '', 'cell']"
          :style="{
              width: item.width + 'px'
          }"
        >
          <span v-if="item.lable === '更多'">
            <a
              :href="`https://www.bom.ai/yunext/${Base64Encode(activeRow.DemandModel)}.html`"
              target="_blank"
            >{{item.lable}}(<span class="more-yunext">{{activeRow.MyYunPriceTotalCount}}</span>)
            </a>
          </span>
          <span v-else>{{item.lable}}</span>
        </div>
      </div>

      <div
        class="list-body"
        v-if="activeRow.MyYunPriceList && activeRow.MyYunPriceList.length > 0"
      >
        <div
          v-for="(item, index) in activeRow.MyYunPriceList"
          :key="index"
          class="list-body-row"
          :class="[item.Supplier.Id === activeRow.SupplierID  ? 'active-supplier' : '']"
        >
          <div
            v-for="(col, j) in Columns"
            :key="j"
            :class="[col.className ? col.className : '', 'cell']"
            :style="{
              width: col.width + 'px'
          }"
          >

            <span v-if="col.lable === '供应商'">
              <span>
                {{item[col.binding]}}
              </span>
              <span
                class="stype-cell"
                :class="[item.CompanyLevel === 4 || item.CompanyLevel === 8 ? 'stype-z' :  item.CompanyLevel === 6 ? 'stype-x' : '']"
              >
                {{item.CompanyLevel === 4 || item.CompanyLevel === 8 ? '正' : item.CompanyLevel === 6 ? '现' : ''}}
              </span>
            </span>
            <span
              v-else
              :class="`column-${col.binding}`"
            >
              {{item[col.binding]}}
            </span>
          </div>
        </div>

      </div>

      <div
        class="list-empty"
        v-else
      >
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { Base64Encode } from '@/assets/scripts/base64';

const Columns = [
  //   {
  //     lable: '云价格',
  //     width: 0,
  //     className: 'column-Price'
  //   },
  {
    lable: '供应商',
    width: 240,
    className: 'column-SupplierName',
    binding: 'SupplierName'
  },
  {
    lable: '型号',
    width: 110,
    binding: 'PartNo'
  },
  {
    lable: '品牌',
    width: 70,
    binding: 'Brand'
  },
  {
    lable: '报价数量',
    width: 80,
    binding: 'QuantityPhrase'
  },
  {
    lable: '报价',
    width: 80,
    binding: 'UnitPriceText'
  },
  {
    lable: '更多',
    width: 80,
    className: 'column-more',
    binding: 'QuotedPhrase'
  }
];
export default {
  name: 'YunPrice',
  props: {
    visible: Boolean,
    loading: Boolean,
    activeRow: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      Columns
    };
  },

  methods: {
    Base64Encode(str) {
      if (!str) {
        return '';
      }
      return Base64Encode(str);
    }
  },

  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
<style lang="scss">
.c-YunPrice {
  width: 660px;
  border: 1px solid #ccc;
  position: fixed;
  background-color: #fff;
  font-size: 12px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
}
.c-YunPrice-list {
  .list-header {
    display: flex;
    border-bottom: 2px solid #ee7700;
    color: #4d4d4d;
    background-color: #f5f5f5;
    .cell {
      line-height: 26px;
      position: relative;
      box-sizing: border-box;
    }
    .column-SupplierName {
      text-align: right;
      padding-right: 50px;
      overflow: hidden;
      height: 26px;
      &::after {
        position: absolute;
        content: '';
        top: -5px;
        left: 26px;
        color: #fff;
        width: 30px;
        height: 50px;
        transform: rotate(-30deg);
        background: linear-gradient(
          180deg,
          rgba(247, 136, 0, 1) 0%,
          rgba(238, 119, 0, 1) 100%
        );
      }
      &::before {
        position: absolute;
        content: '云价格';
        top: 0;
        left: 0;
        color: #fff;
        width: 40px;
        height: 26px;
        z-index: 10;
        background: linear-gradient(
          180deg,
          rgba(247, 136, 0, 1) 0%,
          rgba(238, 119, 0, 1) 100%
        );
      }
    }
    .column-more {
      color: #4d4d4d;
      font-weight: bold;
      .cell {
        cursor: pointer;
      }
    }
    .more-yunext {
      color: #ee7700;
      font-weight: bold;
    }
  }

  .list-empty {
    text-align: center;
    line-height: 100px;
  }

  .list-body {
    color: #333;
    .cell {
      line-height: 24px;
      box-sizing: border-box;
    }
    .column-SupplierName {
      padding-left: 5px;
    }
    .stype-cell {
      padding: 0 3px;
      color: #fff;
      font-size: 12px;
      box-sizing: border-box;
    }
    .stype-z {
      background-color: #ff2200;
      border: 1px solid #ff2200;
    }
    .stype-x {
      background-color: #fdf7a0;
      color: #ff2200;
      border: 1px solid #ff2200;
    }
  }
  .list-body-row {
    display: flex;
    .column-SupplierName {
      &.cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .column-UnitPriceText {
      color: #ee7700;
      font-weight: bold;
    }
    &:nth-child(even) {
      background-color: #f5f5f5;
    }
    &.active-supplier {
      .cell {
        color: #ff2200;
        font-weight: bold;
      }
    }
  }
}
</style>

